import loadingIcon from '@/assets/images/circle-loading.svg';
import { cn } from '@/lib/utils';
import { DMImage } from '../custom-image/custom-image';

type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'bgthird' | 'text' | 'primary_outline';
  type?: 'button' | 'submit';
  onClick?: (event?: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
  formAction?: ((formData: FormData) => void) | (() => void);
  loading?: boolean;
};

export const defaultButtonStyles = 'px-[35px] py-[8px]';
export const allVariants = {
  primary:
    'text-brand-secondary bg-brand-primary font-semibold rounded-md hover:bg-brand-primary-hover flex justify-center',
  primary_outline: 'text-brand-primary border border-brand-primary font-semibold rounded-md',
  secondary: 'text-primary bg-brand-secondary',
  bgthird: 'text-brand-secondary bg-brand-silver rounded-md font-semibold',
  text: 'text-primary font-normal px-0 py-0 hover:text-brand-primary',
};

export const DMButton = ({
  type = 'button',
  children,
  className = '',
  variant = 'text',
  onClick,
  disabled = false,
  formAction,
  loading,
}: ButtonProps) => {
  const currentVariant = `${defaultButtonStyles} ${allVariants[variant]}`;

  if (disabled) {
    // create a div with exact button properties
    return (
      <div
        className={cn(currentVariant, className, {
          'opacity-40 cursor-not-allowed': disabled,
        })}
      >
        {children}
      </div>
    );
  }

  return (
    <button
      formAction={formAction}
      type={type}
      onClick={onClick}
      className={cn(currentVariant, className)}
      disabled={disabled}
    >
      {loading ? (
        <DMImage
          className='animate-spin -ml-1 h-5 w-5 text-white'
          src={loadingIcon}
          width={100}
          height={100}
          alt='loading'
        />
      ) : (
        children
      )}
    </button>
  );
};
